import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import API_BASE_URL from '../../config/api';
import challengeIcon from '../../assets/icons/challenge.png';

const SPORTS = [
  { v: 'correr', l: 'Correr' },
  { v: 'ciclismo', l: 'Ciclismo' },
  { v: 'nadar', l: 'Nadar' },
  { v: 'triatlon', l: 'Triatlon' },
];

export default function CompetitionModal({ show, onHide, date, athleteId, onSaved }) {
  const [form, setForm] = useState({ eventName: '', sport: 'correr', distance: '', priority: 'B', city: '', targetTime: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSave = async () => {
    if (!form.eventName?.trim()) { setError('Nombre del evento es requerido'); return; }
    setSaving(true); setError('');
    try {
      const dateObj = new Date(date);
      await axios.post(`${API_BASE_URL}/api/activities/add`, {
        assignedTo: athleteId,
        type: 'competencia',
        title: form.eventName,
        description: form.distance ? `${form.sport} - ${form.distance}` : form.sport,
        date: dateObj.toISOString(),
        start: dateObj.toISOString(),
        planned: { duracion: form.targetTime || '', distancia: form.distance || '' },
        completed: { duration: '', distance: '', tss: 0, calories: 0 },
        draggable: true,
        external: false,
        isCompetition: true,
        competition: form,
      }, { withCredentials: true });
      onSaved?.();
      onHide();
      setForm({ eventName: '', sport: 'correr', distance: '', priority: 'B', city: '', targetTime: '' });
    } catch (e) {
      setError('Error al guardar la competencia');
    }
    setSaving(false);
  };

  const dateLabel = date ? new Date(date).toLocaleDateString('es-CL', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }) : '';
  const prioColor = { A: '#dc2626', B: '#f59e0b', C: '#6b7280' };
  const prioBg = { A: '#fef2f2', B: '#fef3c7', C: '#f9fafb' };

  return (
    <Modal show={show} onHide={onHide} size="md" centered>
      <Modal.Header closeButton style={{ background: '#E91E63', color: '#fff' }}>
        <Modal.Title style={{ fontSize: 15, display: 'flex', alignItems: 'center', gap: 8 }}>
          <img src={challengeIcon} alt="competencia" width="24" height="24" />
          Agendar competencia - {dateLabel}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: '20px 24px' }}>
        {error && <div style={{ background: '#fef2f2', color: '#dc2626', padding: '8px 12px', borderRadius: 6, marginBottom: 12, fontSize: 13 }}>{error}</div>}
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 4 }}>Nombre del evento *</label>
          <input value={form.eventName} onChange={e => set('eventName', e.target.value)}
            placeholder="Ej: Maraton de Santiago"
            style={{ width: '100%', border: '1px solid #e5e7eb', borderRadius: 6, padding: '8px 12px', fontSize: 13, outline: 'none', fontFamily: 'inherit' }} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 6 }}>Deporte</label>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {SPORTS.map(s => (
              <button key={s.v} onClick={() => set('sport', s.v)} type="button"
                style={{ padding: '5px 10px', borderRadius: 16, border: `1.5px solid ${form.sport === s.v ? '#E91E63' : '#e5e7eb'}`,
                  background: form.sport === s.v ? '#fce4ec' : '#fff', color: '#374151', cursor: 'pointer', fontSize: 11, fontFamily: 'inherit' }}>
                {s.l}
              </button>
            ))}
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
          <div>
            <label style={{ fontSize: 11, color: '#6b7280', display: 'block', marginBottom: 3 }}>Distancia / Formato</label>
            <input value={form.distance} onChange={e => set('distance', e.target.value)}
              placeholder="42K, Sprint, Olimpico..."
              style={{ width: '100%', border: '1px solid #e5e7eb', borderRadius: 6, padding: '6px 10px', fontSize: 13, outline: 'none', fontFamily: 'inherit' }} />
          </div>
          <div>
            <label style={{ fontSize: 11, color: '#6b7280', display: 'block', marginBottom: 3 }}>Prioridad</label>
            <div style={{ display: 'flex', gap: 6 }}>
              {['A', 'B', 'C'].map(p => (
                <button key={p} onClick={() => set('priority', p)} type="button"
                  style={{ flex: 1, padding: '6px', borderRadius: 6, border: `1.5px solid ${form.priority === p ? prioColor[p] : '#e5e7eb'}`,
                    background: form.priority === p ? prioBg[p] : '#fff',
                    color: form.priority === p ? prioColor[p] : '#9ca3af',
                    cursor: 'pointer', fontSize: 12, fontWeight: 600, fontFamily: 'inherit' }}>
                  {p}
                </button>
              ))}
            </div>
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 4 }}>
          <div>
            <label style={{ fontSize: 11, color: '#6b7280', display: 'block', marginBottom: 3 }}>Ciudad</label>
            <input value={form.city} onChange={e => set('city', e.target.value)}
              placeholder="Santiago"
              style={{ width: '100%', border: '1px solid #e5e7eb', borderRadius: 6, padding: '6px 10px', fontSize: 13, outline: 'none', fontFamily: 'inherit' }} />
          </div>
          <div>
            <label style={{ fontSize: 11, color: '#6b7280', display: 'block', marginBottom: 3 }}>Objetivo de tiempo</label>
            <input value={form.targetTime} onChange={e => set('targetTime', e.target.value)}
              placeholder="3:15:00"
              style={{ width: '100%', border: '1px solid #e5e7eb', borderRadius: 6, padding: '6px 10px', fontSize: 13, outline: 'none', fontFamily: 'inherit' }} />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button onClick={onHide} style={{ background: '#6b7280', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 16px', cursor: 'pointer', fontFamily: 'inherit' }}>Cancelar</button>
        <button onClick={handleSave} disabled={saving}
          style={{ background: '#E91E63', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 16px', cursor: 'pointer', fontFamily: 'inherit', opacity: saving ? 0.7 : 1 }}>
          {saving ? 'Guardando...' : 'Agendar'}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
